import React, { Component } from "react";
import { connect } from "react-redux";
import PopUpForm from "../../Generic/PopUpDialog/PopUpForm";
import { contactFields } from "../fields";
import { API } from "aws-amplify";
import { setRefresh } from "../../../actions/algoliaActions";
import { setLoaderState, setAlgoliaLoaderState } from "../../../actions/loaderActions";
import { updateContactDetails, selectContact } from "../../../actions/manufacturersActions";

class AddContact extends Component {
  manufacturerId = this.props.match.params.manufacturerId;
  branchId = this.props.match.params.branchId;

  async APIMethod(formData) {
    this.props.dispatch(setAlgoliaLoaderState(true));
    try {
      this.props.dispatch(setLoaderState(true));

      const response = await API.post(
        "telishadeAPI",
        `/manufacturer/${this.manufacturerId}/branch/${this.branchId}/contact`,
        {
          body: {
            details: {
              firstName: formData.firstName,
              lastName: formData.lastName,
              title: formData.title,
              email: formData.email,
              phone: formData.phone,
              fax: formData.fax,
              mobile: formData.mobile
            }
          }
        }
      );

      await this.props.dispatch(updateContactDetails(response.details));
      await this.props.dispatch(selectContact(response.id));
      this.props.history.push(
        `/manufacturers/${response.manufacturerId}/branches/${this.branchId}/contacts/${response.id}`
      );
    } catch (error) {
      throw error;
    } finally {
      this.props.dispatch(setLoaderState(false));
    }

    // Refresh any algolia components currently mounted 1 second after updating
    setTimeout(() => {
      this.props.dispatch(setRefresh(true));
      this.props.dispatch(setRefresh(false));
      this.props.dispatch(setAlgoliaLoaderState(false));
    }, 0);
  }

  render() {
    const fields = [...contactFields];

    return (
      <PopUpForm
        fields={fields}
        header="Add New Contact"
        button="ACCEPT"
        buttoncolour="green"
        button2="CANCEL"
        button2colour="red"
        buttonClickHandler={undefined}
        button2ClickHandler={undefined}
        apiMethod={details => this.APIMethod(details)}
      />
    );
  }
}
const mapStateToProps = state => {
  return state.manufacturers.contact;
};

export default connect(mapStateToProps)(AddContact);
